import { ListSearchExportsRequest } from '@fullstory/proto/fs/services/dex';

/** This type is used to support the `exportIdsByFilter` reducer */
export type SearchExportFilterType = Pick<ListSearchExportsRequest, 'creator' | 'stateRollup'>;

export const allSearchExportsFilter: SearchExportFilterType = { creator: '', stateRollup: 0 };

/** Returns the key used in the `exportIdsByFilter` reducer */
export const makeSearchExportFilterKey = (f: SearchExportFilterType): string =>
  `${f.creator ?? ''}#${f.stateRollup ?? 0}`;

/** Returns a list of keys to which the provided filter type will map to. */
export const filterKeyCombo = (f: SearchExportFilterType): string[] =>
  [
    allSearchExportsFilter,
    { creator: f.creator, stateRollup: 0 },
    { creator: '', stateRollup: f.stateRollup },
    { creator: f.creator, stateRollup: f.stateRollup },
  ].map(makeSearchExportFilterKey);
